import { c as _c } from "react/compiler-runtime";
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { PianoIdentity } from '../../layout/PianoIdentity';
import { PrintButton } from '../../layout/PrintButton';
import { useAnalyzedKeyboard } from '../../../hooks/keyboard/use-analyzed-keyboard';
import { useTranslation } from '@/hooks/use-translation';
import { AnalyzeDataSheet } from '@/components/analyze/data-sheet/AnalyzeDataSheet';
export const AnalyzeDataSheetPage = () => {
  const $ = _c(13);
  const analyzedKeyboard = useAnalyzedKeyboard();
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PianoIdentity /><PrintButton /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <em className="ptl-accent">Sheet</em>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== t) {
    t2 = <Trans t={t} i18nKey="Data <1>Sheet</1>">Data {t1}</Trans>;
    t3 = t("Every measured and computed value, key by key, in grams.");
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <PageHeading title={t2} lede={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== analyzedKeyboard) {
    t5 = <AnalyzeDataSheet analyzedKeyboard={analyzedKeyboard} />;
    $[8] = analyzedKeyboard;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <MainLayout headerRight={t0}>{t4}{t5}</MainLayout>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};